import { render } from "./CaptchaCanvas.vue?vue&type=template&id=2222cfe4&scoped=true&ts=true"
import script from "./CaptchaCanvas.vue?vue&type=script&lang=ts"
export * from "./CaptchaCanvas.vue?vue&type=script&lang=ts"

import "./CaptchaCanvas.vue?vue&type=style&index=0&id=2222cfe4&scoped=true&lang=css"

import exportComponent from "F:\\200 Desarrollos\\SIE\\SIE-Publico\\SIE.Frontend\\WEB.Home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2222cfe4"]])

export default __exports__